import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { POI, POICategory, POIState } from "./types/poi.types";

const initialState: POIState = {
  isLoading: false,
  error: null,
  pois: [],
  categories: [],
};

const poiSlice = createSlice({
  name: "poi",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setPois: (state, action: PayloadAction<POI[]>) => {
      const categoryMap = new Map(state.categories.map((c) => [c.extId, c]));
      // Join category objects onto each POI via categoryId
      state.pois = action.payload.map((poi) => ({
        ...poi,
        category: poi.categoryId ? categoryMap.get(poi.categoryId) : undefined,
      }));
      state.isLoading = false;
      state.error = null;
    },
    setCategories: (state, action: PayloadAction<POICategory[]>) => {
      state.categories = action.payload;
      // Re-join categories onto existing POIs when categories arrive
      const categoryMap = new Map(action.payload.map((c) => [c.extId, c]));
      state.pois = state.pois.map((poi) => ({
        ...poi,
        category: poi.categoryId ? categoryMap.get(poi.categoryId) : undefined,
      }));
    },
  },
});

export const { setLoading, setError, setPois, setCategories } =
  poiSlice.actions;

export default poiSlice.reducer;
